/**
 * Downloads the url or url-encoded image as a file.
 */
export function download(url: string, fileName: string) {
  const link = document.createElement('a')
  link.download = fileName
  link.href = url
  link.click()
}

/**
 * Downloads the blob as a file.
 */
export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  download(url, fileName)
  URL.revokeObjectURL(url)
}
